import { dateFunc } from "@/components/Functions/dateFunc";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

export const useColumnImportandExportDefs = () => {
  const { t } = useTranslation();
  const { abbreviation } = useSelector((state: any) => state.case);

  return [
    {
      comparator: () => 0,

      field: "documentName",
      type: "documentNameType",
      headerName: t("pages.importHistory.tableColumnsDetails.column2"),
      sortable: true,
      unSortIcon: true,
      flex: 1,
      minWidth: 150,
      cellRenderer: "nameCellRenderer",
    },
    {
      cellRenderer: "entityTypeCellRenderer",
      comparator: () => 0,

      field: "entityType",
      type: "entityTypeType",
      headerName: t("pages.importHistory.tableColumnsDetails.column3"),
      sortable: true,
      unSortIcon: true,
      flex: 1.6,
      minWidth: 150,
      wrapText: true,
      autoHeight: true,
    },
    {
      comparator: () => 0,

      field: "totalRecords",
      type: "totalRecordsType",
      headerName: t("pages.importHistory.tableColumnsDetails.column4"),
      flex: 1,
      minWidth: 150,
      cellClass: "align-right",
      headerClass: "stepHeaderClass",
      sortable: true,
      unSortIcon: true, // headerComponent:CustomHeaderImport
    },

    {
      comparator: () => 0,
      flex: 1,
      minWidth: 150,
      field: "recordsFailed",
      type: "recordsFailedType",
      headerName: t("pages.importHistory.tableColumnsDetails.column5"),
      cellClass: "align-right",
      headerClass: "stepHeaderClass",
      cellRenderer: "recordsFailed",
      sortable: true,
      unSortIcon: true,
      // headerComponent:CustomHeaderImport
    },
    {
      comparator: () => 0,

      field: "status",
      type: "statusType",
      headerName: t("pages.importHistory.tableColumnsDetails.column6"),
      sortable: true,
      unSortIcon: true,
      flex: 1,
      minWidth: 150,
      // headerComponent:CustomHeaderImport,

      cellRenderer: function (params: any) {
        if (params.data.status === 1) {
          return t("pages.importHistory.statusLabels.inProgress");
        } else if (params.data.status === 2) {
          return t("pages.importHistory.statusLabels.success");
        } else if (params.data.status === 3) {
          return t("pages.importHistory.statusLabels.failed");
        } else if (params.data.status === 0) {
          return t("pages.importHistory.statusLabels.queued");
        } else {
          return "-";
        }
      },
    },
    {
      comparator: () => 0,
      flex: 1,
      minWidth: 200,
      field: "createdBy",
      type: "createdByType",
      headerName: t("pages.importHistory.tableColumnsDetails.column7"),
      cellRenderer: "createdBy",
      sortable: true,
      unSortIcon: true,
    },
    {
      comparator: () => 0,
      flex: 1,
      minWidth: 200,
      field: "createdOn",
      type: "createdOnType",
      headerName: t("pages.importHistory.tableColumnsDetails.column8"),
      sortable: true,
      unSortIcon: true,
      cellRenderer: function (params: any) {
        return `${
          dateFunc(params.data.createdOn).formattedDateTime
        } ${abbreviation}`;
      },
    },
  ];
};
